import React from 'react';
import { EventType } from '@graphql/generated';
import { SearchBanner } from '@shared/createEvent/SearchBanner';
import { CreateAccount } from '@shared/createEvent/CreateAccount';
import { EventDetailsContainer } from '@shared/createEvent/EventDetailsContainer/EventDetailsContainer';
import { useTranslation } from '@shared/core';

import { CREATE_BABY_REGISTRY_APP_NAME } from '@apps/createBabyRegistry/constants';

export const CreateAccountWrapper = () => {
  const { t2 } = useTranslation('createEvent');

  const { heroText, helpText } = t2('createAccount', 'babyRegistry');

  return (
    <EventDetailsContainer topBanner={<SearchBanner eventType={EventType.babyRegistry} />} header={{ title: heroText, subTitle: helpText, showLogo: true }}>
      <CreateAccount appName={CREATE_BABY_REGISTRY_APP_NAME} eventType={EventType.babyRegistry} />
    </EventDetailsContainer>
  );
};
